<template>
    <TopNav />
    <div class="contact__form mx-auto">
        <h1 class="title mx-auto mb-3">Contact Us</h1>
        <p>
            <input id="email" type="email" placeholder="Email" />
        </p>
        <p>
            <input id="name" type="text" placeholder="Name" />
        </p>
        <p>
            <textarea id="message" rows="3" type="text" placeholder="Message" />
        </p>
        <SolidButton @click="sendContact" text="Send Message" />
        <v-dialog v-model="dialog" max-width="500" class="text-center">
            <v-card>
                <v-card-text> Your message has been sent. </v-card-text>
                <v-card-actions>
                    <v-btn color="#ffb700" block @click="dialog = false"
                        >OK!</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import SolidButton from "@/components/SolidButton.vue";
import { ref } from "vue";
import TopNav from "@/components/TopNav.vue";
import router from "@/router";
import { getFirestore, doc, setDoc } from "firebase/firestore";

export default {
    name: "ContactView",
    components: {
        SolidButton,
        TopNav,
    },
    setup() {
        const dialog = ref(false);

        const sendContact = () => {
            const email = document.getElementById("email").value;
            const name = document.getElementById("name").value;
            const message = document.getElementById("message").value;
            if (email.length != 0 && name.length != 0 && message.length != 0) {
                dialog.value = true;
                document.getElementById("email").value = "";
                document.getElementById("name").value = "";
                document.getElementById("message").value = "";
                const db = getFirestore();
                const uuid = crypto.randomUUID();
                const unix_epoch = Math.floor(new Date().getTime() / 1000);
                try {
                    setDoc(doc(db, "contact_messages/" + uuid), {
                        timestamp: unix_epoch,
                        email: email,
                        name: name,
                        message: message,
                    });
                    console.log("Message Sent");
                } catch (e) {
                    console.error("Error sending message: ", e);
                }
            } else {
                alert("Please fill all fields so we can help you best!");
            }
        };

        return {
            sendContact,
            dialog,
        };
    },
};
</script>

<style lang="scss">
.contact__form {
    width: 100%;
    max-width: 350px;

    display: flex;
    flex-direction: column;
    align-content: stretch;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    input,
    textarea {
        width: 100%;
        margin-bottom: 10px;
        padding: 5px 10px;
        background-color: #fff !important;
        border: 1px solid $light-gray;
        border-radius: 5px;
        outline: none;

        &:focus {
            border: 2px solid $yellow !important;
        }
    }
    input {
        height: 50px;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px white inset !important;
    }

    button {
        height: 50px !important;
        margin-top: 20px;
    }
}
</style>
